/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'H'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPH000001',
    EAPZ000003: 'EAPH000003',
    EAPZ000004: 'EAPH000004',
    EAPZ000009: 'EAPH000009',
    EAPZ000010: 'EAPH000010',
    EAPZ000018: 'EAPH000018',
    EAPZ000019: 'EAPH000019',
    EAPZ000020: 'EAPH000020',
    EAPZ000050: 'EAPH000050',
    EAPZ000051: 'EAPH000051',
    EBAZ000015: 'EBAH000015',
    EBAA000002: 'EBAH100002',
    EBAA000003: 'EBAH100003',
    EIFA000001: 'EIFH100001',
    EIFA000002: 'EIFH100002',
    EIFA000003: 'EIFH100003',
    EIFA000004: 'EIFH100004',
    EIFA000005: 'EIFH100005',
    EIFA000006: 'EIFH100006',
    EIFA000007: 'EIFH100007',
    EIFA000009: 'EIFH100009',
    EIFA000010: 'EIFH100010',
    EIFA000011: 'EIFH100011',
    FDXZ000005: 'FDXH000005',
    FIFA000001: 'FIFH100001',
    // ここから画面固有
    EAPZ000027: 'EAPH000027',
    EBAA000028: 'EBAH100028',
    EBAZ000023: 'EBAH000023',
    EBAZ000078: 'EBAH000078',
    EBAZ000096: 'EBAH000096',
    EBAZ000097: 'EBAH000097',
    EBAZ000098: 'EBAH000098',
    EBAZ000106: 'EBAH000106',
    EBAZ000143: 'EBAH000143',
    EBAZ000145: 'EBAH000145',
    EBAZ000146: 'EBAH000146',
    EBAZ000147: 'EBAH000147',
    EBAZ000149: 'EBAH000149',
    EBAZ000151: 'EBAH000151',
    EBAZ000155: 'EBAH000155',
    EBAZ000157: 'EBAH000157',
    EBAZ000159: 'EBAH000159',
    EBAZ000160: 'EBAH000160',
    EBAZ000161: 'EBAH000161',
    EBAZ000162: 'EBAH000162',
    EBAZ000163: 'EBAH000163',
    EBAZ000164: 'EBAH000164',
    EBAZ000165: 'EBAH000165',
    EBAZ000189: 'EBAH000189',
    EBAZ000190: 'EBAH000190',
    EBAZ000191: 'EBAH000191',
    EBAZ000192: 'EBAH000192',
    EBAZ000193: 'EBAH000193',
    EBAZ000194: 'EBAH000194',
    EBAZ000195: 'EBAH000195',
    EBAZ000196: 'EBAH000196',
    EBAZ000197: 'EBAH000197',
    EBAZ000198: 'EBAH000198',
    EBAZ000246: 'EBAH000246',
    EBAZ000247: 'EBAH000247',
    EBAZ000248: 'EBAH000248',
    EBAZ000251: 'EBAH000251',
    EBAZ000252: 'EBAH000252',
    EBAZ000253: 'EBAH000253',
    EBAZ000254: 'EBAH000254',
    EBAZ000255: 'EBAH000255',
    EBAZ000256: 'EBAH000256',
    EBAZ000257: 'EBAH000257',
    EBAZ000258: 'EBAH000258',
    EBAZ000259: 'EBAH000259',
    EBAZ000260: 'EBAH000260',
    EBAZ000261: 'EBAH000261',
    EBAZ000262: 'EBAH000262',
    EBAZ000263: 'EBAH000263',
    EBAZ000264: 'EBAH000264',
    EBAZ000265: 'EBAH000265',
    EBAZ000266: 'EBAH000266',
    EBAZ000267: 'EBAH000267',
    EBAZ000268: 'EBAH000268',
    EBAZ000269: 'EBAH000269',
    EBAZ000270: 'EBAH000270',
    EBAZ000271: 'EBAH000271',
    EBAZ000298: 'EBAH000298',
    EBAZ000303: 'EBAH000303',
    EBAZ000304: 'EBAH000304',
    EBAZ000314: 'EBAH000314',
    EBAZ000315: 'EBAH000315',
    EBAZ000316: 'EBAH000316',
    EBAZ000367: 'EBAH000367',
    EBAZ000380: 'EBAH000380',
    EBAZ000384: 'EBAH000384',
    EBAZ000385: 'EBAH000385',
    EBAZ000386: 'EBAH000386',
    EBAZ000394: 'EBAH000394',
    EBAZ000396: 'EBAH000396',
    EBAZ000404: 'EBAH000404',
    EBAZ000406: 'EBAH000406',
    EBAZ000407: 'EBAH000407',
    EBAZ000408: 'EBAH000408',
    EBAZ000409: 'EBAH000409',
    EBAZ000410: 'EBAH000410',
    EBAZ000411: 'EBAH000411',
    EBAZ000413: 'EBAH000413',
    EBAZ000414: 'EBAH000414',
    EBAZ000416: 'EBAH000416',
    EBAZ000417: 'EBAH000417',
    EBAZ000418: 'EBAH000418',
    EBAZ000419: 'EBAH000419',
    EBAZ000421: 'EBAH000421',
    EBAZ000433: 'EBAH000433',
    EBAZ000434: 'EBAH000434',
    EBAZ000500: 'EBAH000500',
    EBAZ000520: 'EBAH000520',
    EBAZ000544: 'EBAH000544',
    EBAZ000584: 'EBAH000584',
    EBAZ000585: 'EBAH000585',
    EBAZ000587: 'EBAH000587',
    EBAZ000589: 'EBAH000589',
    EBAZ000596: 'EBAH000596',
    EBAZ000597: 'EBAH000597',
    EBAZ000615: 'EBAH000615',
    EBAZ000631: 'EBAH000631',
    EBAZ000638: 'EBAH000638',
    EBAZ000662: 'EBAH000662',
    EBAZ000674: 'EBAH000674',
    EBAZ000675: 'EBAH000675',
    EBAZ000676: 'EBAH000676',
    EBAZ000684: 'EBAH000684',
    EBAZ000707: 'EBAH000707',
    EBAZ000708: 'EBAH000708',
    EBAZ000709: 'EBAH000709',
    EBAZ000713: 'EBAH000713',
    EBAZ000722: 'EBAH000722',
    EBAZ000724: 'EBAH000724',
    EBAZ000727: 'EBAH000727',
    EBAZ000735: 'EBAH000735',
    EBAZ000736: 'EBAH000736',
    EBAZ000737: 'EBAH000737',
    EBAZ000738: 'EBAH000738',
    EBAZ000739: 'EBAH000739',
    EBAZ000745: 'EBAH000745',
    EBAZ000746: 'EBAH000746',
    EBAZ000747: 'EBAH000747',
    EBAZ000748: 'EBAH000748',
    EBAZ000749: 'EBAH000749',
    EBAZ000751: 'EBAH000751',
    EBAZ000752: 'EBAH000752',
    EBAZ000754: 'EBAH000754',
    EBAZ000755: 'EBAH000755',
    EBAZ000756: 'EBAH000756',
    EBAZ000767: 'EBAH000767',
    EBAZ000773: 'EBAH000773',
    EBAZ000778: 'EBAH000778',
    EBAZ000820: 'EBAH000820',
    EBAZ000822: 'EBAH000822',
    EBAZ000843: 'EBAH000843',
    EBAZ000846: 'EBAH000846',
    EBAZ000847: 'EBAH000847',
    EBAZ000848: 'EBAH000848',
    EBAZ000700: 'EBAH000700',
    EBAZ000702: 'EBAH000702',
    EBAZ000777: 'EBAH000777',
    ECLZ000001: 'ECLH000001',
    ECLZ000002: 'ECLH000002',
    ECLZ000003: 'ECLH000003',
    FOTO000001: 'FOTH000001',
    WBAZ000029: 'WBAH000029',
    WBAZ000030: 'WBAH000030',
    WBAZ000031: 'WBAH000031',
    WBAZ000032: 'WBAH000032',
    WBAZ000033: 'WBAH000033',
    WBAZ000034: 'WBAH000034',
    WBAZ000035: 'WBAH000035',
    WBAZ000036: 'WBAH000036',
    WBAZ000037: 'WBAH000037',
    WBAZ000038: 'WBAH000038',
    WBAZ000039: 'WBAH000039',
    WBAZ000040: 'WBAH000040',
    WBAZ000043: 'WBAH000043',
    WBAZ000044: 'WBAH000044',
    WBAZ000045: 'WBAH000045',
    WBAZ000048: 'WBAH000048',
    WBAZ000152: 'WBAH000152',
    WBAZ000198: 'WBAH000198',
    WBAZ000213: 'WBAH000213',
    WBAZ000214: 'WBAH000214',
    WBAZ000218: 'WBAH000218',
    WBAZ000219: 'WBAH000219',
    WBAZ000223: 'WBAH000223',
    WBAZ000224: 'WBAH000224',
    WBAZ000225: 'WBAH000225',
    WBAZ000226: 'WBAH000226',
    WBAZ000238: 'WBAH000238',
    WBAZ000239: 'WBAH000239',
    WBAZ000241: 'WBAH000241',
    WBAZ000242: 'WBAH000242',
    WBAZ000253: 'WBAH000253',
    WBAZ000254: 'WBAH000254',
    WBAZ000257: 'WBAH000257',
    WBAZ000355: 'WBAH000355',
    WBAZ000389: 'WBAH000389',
    WBAZ000428: 'WBAH000428',
    WBAZ000556: 'WBAH000556',
    WBAZ000557: 'WBAH000557',
    WBAZ000558: 'WBAH000558',
    WBAZ000562: 'WBAH000562',
    WBAZ000563: 'WBAH000563',
    WBAZ000564: 'WBAH000564',
    WBAZ000573: 'WBAH000573',
    WBAZ000577: 'WBAH000577',
    WBAA100012: 'WBAH100012',
    EBAA000029: 'EBAH100029',
    EBAA000030: 'EBAH100030',
    EBAA000037: 'EBAH100037',
    EBAA000046: 'EBAH100046',
    FIFA000002: 'FIFH100002',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'ADO',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'SPKHD08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'SPKHD08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'SPKHD08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'alphaNumberic' as 'alphaNumberic' | 'numberic',
    length: 10,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 20,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: true,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: true,
  LOGO_FILE_PATH: 'assets/images/logo_ado.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_ado_biz.png',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000010]: 'EA026',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA015', // ifly接続エラー(想定外エラー)
    [ErrorCodeConstants.ERROR_CODES.FIFA000002]: 'EA019', // iflyエラー
  } as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  // 画像の定数一覧
  IMG: {
    LOGO_S: 'assets/images/logo_ado_s.svg',
    LOGO_BIZ: 'assets/images/logo_ado_biz.png',
    LOGO_S_WIDTH: '56',
    LOGO_S_HEIGHT: '22',
    LOGO_BIZ_WIDTH: '', // ADOは法人無し
    LOGO_BIZ_HEIGHT: '', // ADOは法人無し

    // ツールチップ
    ICON_HELP: 'assets/images/icon_help_ado_blue_20.svg',

    // S01-P010-S01-U: 予約検索画面
    S01_P010_S01_U_XXX: '',

    // S01-P020-S01-U: 予約一覧画面
    S01_P020_S01_U_XXX: '',
    S01_P020_S01_U__ICON__ERROR_TRI_20: `assets/images/icon_error_tri_ado_red_20.svg`,
    S01_P020_S01_U__ICON__LINK_PRIMARY_20: `assets/images/icon_link_ado_blue_20.svg`,

    // S01-P030-S01-U: 予約詳細画面
    S01_P030_S01_U_XXX: '',
    S01_P030_S01_U__LINK: 'assets/images/icon_link_ado_blue_20.svg',
    S01_P030_S01_U__PLANE_ACTIVE: 'assets/images/icon_plane_line_ado_blue_32.svg',
    S01_P030_S01_U__AVATOR_ACTIVE: 'assets/images/icon_avator_ado_blue_32.svg',
    S01_P030_S01_U__CHECKIN_SEAT_ACTIVE: 'assets/images/icon_checkin_seat_ado_blue_32.svg',
    S01_P030_S01_U__TOOLTIP: 'icon_help_ado_blue_20.svg',
    S01_P030_S01_U__ANOTHER_WINDOW: 'assets/images/icon_external_ado_blue_16.svg',
    S01_P030_S01_U__Wifi_AVAILABLE: '',
    S01_P030_S01_U__Wifi_NOT_AVAILABLE: '',
    S01_P030_S01_U__Wifi_POSSIBLY_AVAILABLE: '',

    // S01-P031-S01-U: 予約詳細(旅程)画面
    S01_P031_S01_U_XXX: '',

    // S01-P032-S01-U: 予約詳細(搭乗者)画面
    S01_P032_S01_U_XXX: '',

    // S01-P033-S01-U: 予約詳細(サービス)画面
    S01_P033_S01_U_XXX: '',

    // S02-P013-S01-U: ジュニアパイロット申込画面
    S02_P013_S01_U_XXX: '',

    // S03-P010-S01-U: シートマップ画面
    S03_P010_S01_U_XXX: '',
    S03_P010_S01_U__SEATMAP__SEATMAP_AISLE_SHORT: `assets/images/seatmap_aisle_short.svg`,
    S03_P010_S01_U__SEGMENTS__ICON_CHECK_PRIMARY_20: `assets/images/icon_check_ado_blue_20.svg`,
    S03_P010_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16: `assets/images/icon_external_ado_blue_16.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_LEFT_40: `assets/images/btn_arrow_circle_left_40.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_RIGHT_40: `assets/images/btn_arrow_circle_right_40.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_DETAIL: `不使用`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_SEATTYPE: `assets/images/seatmap_float_seattype_ado.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_LEGEND: `assets/images/seatmap_float_legend_ado.svg`,
    S03_P010_S01_U__SEAT_EXITDOOR: `assets/images/seat_exitdoor.svg`,
    S03_P010_S01_U__SEAT_FREE_SEAT_24: `assets/images/seat_ado_seat_24.svg`,
    S03_P010_S01_U__SEAT_BACK_SEAT_24: `assets/images/seat_back_seat_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_SEAT_24: `assets/images/seat_emergency_exit_seat_ado_24.svg`,
    S03_P010_S01_U__SEAT_UNAVAILABLE_24: `assets/images/seat_unavailable_24.svg`,
    S03_P010_S01_U__SEAT_INFANT_24: `assets/images/seat_infant_24.svg`,
    S03_P010_S01_U__SEAT_SELECTED_24: `assets/images/seat_selected_ado_24.svg`,
    S03_P010_S01_U__SEAT_BEFORE_CHANGE_FREE_SEAT_24: `assets/images/seat_before_change_free_seat_ado_24.svg`,
    S03_P010_S01_U__SEAT_UNCHANGEABLE_24: `assets/images/seat_unchangeable_ado_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW_24: `assets/images/seat_no_window_ado_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW: `assets/images/seat_no_window_ado.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINING_24: `assets/images/seat_no_reclining_ado_24.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINE: `assets/images/seat_no_recline_ado.svg`,
    S03_P010_S01_U__SEAT_TABLE_24: `assets/images/seat_table_24.svg`,
    S03_P010_S01_U__SEAT_LAVATORY_24: `assets/images/seat_lavatory_ado_24.svg`,
    S03_P010_S01_U__SEAT_MULTI_PURPOSE_ROOM_24: `assets/images/seat_multi_purpose_room_24.svg`,
    S03_P010_S01_U__SEAT_AISLE_24: `assets/images/seat_aisle_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_24: `assets/images/seat_emergency_exit_24.svg`,
    S03_P010_S01_U__SEAT_WING_24: `assets/images/seat_wing_ado_24.svg`,
    S03_P010_S01_U__SEAT_GALLEY_24: `assets/images/seat_galley_ado_24.svg`,
    S03_P010_S01_U__SEAT_PARTITION_24: `assets/images/seat_partition_24.svg`,
    S03_P010_S01_U__SEAT_BAR_24: `assets/images/seat_bar_24.svg`,
    S03_P010_S01_U__SEAT_STAIR_24: `assets/images/seat_stair_24.svg`,
    S03_P010_S01_U__SEAT_BASSINET_24: `assets/images/seat_bassinet_24.svg`,

    // S03-P020-S01-U: 座席属性指定画面
    S03_P020_S01_U_XXX: '',

    // S03-P030-S01-U: シートマップ（参照）画面
    S03_P030_S01_U_XXX: '',

    // S04-P010-S01-U: 搭乗者情報入力画面
    S04_P010_S01_U_XXX: '',

    // S05-P011-S01-U: 領収書選択画面
    S05_P011_S01_U_XXX: '',

    // S05-P020-S01-U: 搭乗証明書検索画面
    // TODO: 定数が確定するまでの暫定です
    S05_P020_S01_U_XXX: '',
    S05_P020_S01_U__TOOLTIP: 'assets/images/icon_help_ado_blue_24.svg',
  },

  // 定数一覧
  CARRIER: {
    TWO_LETTER: 'HD',
    THREE_LETER: 'ADO',
  },

  //オフィス
  OFFICE: {
    OFFICE_CODE_WEB: 'SPKHD08SS', //WEB社用オフィス
  },
} as const;
